import { CreateCampaignPreviewView, GrowthDashboardTopBarActions } from '@elva/ui';
import { useNavigate, useParams } from 'react-router-dom';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useAcceptCampaignSuggestion, useCampaignDraft } from '../hooks/useCreateCampaign';

export function CreateCampaignPreviewPage() {
  const navigate = useNavigate();
  const { suggestionId = '' } = useParams();

  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } =
    useCampaignDraft(suggestionId);
  const accept = useAcceptCampaignSuggestion();

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
      isEmpty={data === null}
    >
      <CreateCampaignPreviewView
        {...viewProps({
          draft: data ?? undefined,
          loading: isFetching || accept.isPending,
          onBack: () => navigate('/campaigns/create'),
          onLaunch: () => {
            accept.mutate(suggestionId, {
              onSuccess: () => navigate('/campaigns'),
            });
          },
        })}
      />
    </AsyncBoundary>
  );
}
